import * as React from "react";
import { SVGProps, memo } from "react";

const SvgBellBlue = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.75 19a.728.728 0 0 1-.75-.75.728.728 0 0 1 .75-.75H6V9.9c0-1.4.412-2.654 1.237-3.763C8.063 5.03 9.15 4.333 10.5 4.05V3.5c0-.417.146-.77.438-1.063A1.447 1.447 0 0 1 12 2c.417 0 .77.146 1.063.438.291.291.437.645.437 1.062v.55c1.35.283 2.438.98 3.262 2.088C17.587 7.245 18 8.5 18 9.9v7.6h1.25a.728.728 0 0 1 .75.75.728.728 0 0 1-.75.75H4.75ZM12 22c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 10 20h4c0 .55-.196 1.02-.588 1.413A1.926 1.926 0 0 1 12 22Z"
      fill="#128AE0"
    />
  </svg>
);

const Memo = memo(SvgBellBlue);

export default Memo;
